import { useTranslation } from 'next-i18next';

import { useScrollPosition } from '@hooks/useScrollPosition';
import { useReadStoryStore } from '@stores/useReadStoryStore';

import Adfit from '@components/common/Adfit';
import NativeInFeedAd from '@components/common/NativeInFeedAd';
import Empty from '@components/common/Empty';
import { LinkItem } from '@components/common/ListItem';
import { PaginationIterator } from '@components/common/Pagination';
import ReadStory from '@components/stories/ReadStory';

import { ReadStorySort, fetchReadStories } from '@api/story';
import { QUERY_KEYS, StoryTheme } from '@constants';
import { usePaginationQuery } from '@utils/query';

const ReadStoryList = ({
  sort,
  isEdit,
}: {
  sort: ReadStorySort;
  isEdit: boolean;
}) => {
  const { t } = useTranslation();
  const { setReadStoryIds } = useReadStoryStore();
  const queryKey = QUERY_KEYS.READ_STORY.LIST(sort);
  const query = usePaginationQuery(
    queryKey,
    ({ pageParam }) => fetchReadStories(sort, pageParam),
    {
      onSuccess(data) {
        setReadStoryIds(data.pages);
      },
    }
  );

  useScrollPosition(`readStoryList:${sort}`);

  return (
    <>
      <PaginationIterator
        name="read-story-list"
        query={query}
        border
        ad={<Adfit type="library" />}
        inFeedAd={<NativeInFeedAd unitKey="story_mobile" />}
      >
        {(item) => (
          <LinkItem
            to={
              item.theme === StoryTheme.iknow
                ? `/stories/${item.id}/licensed`
                : `/stories/${item.id}`
            }
            newTab
            hideArrow
            left={<ReadStory {...item} isEdit={isEdit} />}
          />
        )}
      </PaginationIterator>
      {query && !query.totalCount && (
        <Empty query={query}>
          <p>{t('읽은 작품이 없습니다.')}</p>
        </Empty>
      )}
    </>
  );
};

export default ReadStoryList;
